<template>
	<div class="container py-5">
        <h2>{{ $t('modelingDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="form-label">{{ $t('name') }}</label>
                <input class="form-control" v-model="data.name">
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('currency') }}</label>
                <input class="form-control" v-model="data.currency">
            </div>
        </div>
        <div class="row col-md-12">
            <label class="form-label">{{ $t('groups') }}</label>
            <div class="col-md-3" v-for="(item, i) in groups" :key="i">
                <div class="input-group mb-3">
                    <label class="form-control readonly" :for="'group_' + i">{{item.name}}</label>
                    <div class="input-group-text">
                        <input class="form-check-input mt-0" type="checkbox" :id="'group_' + i" @change="groupCheck(item, $event)" :checked="isGroupChecked(item)">
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="form-label" style="display:block">&nbsp;</label>
                <button class="btn btn-primary" v-on:click="saveModeling">{{ $t('save') }}</button>
            </div>
        </div>
        <GroupToModelingDialog v-show="isModalVisible" @close="closeModal" @confirm="confirmModal"></GroupToModelingDialog>
    </div>
</template>

<script>
import GroupToModelingDialog from "./GroupToModelingDialog";
import ModelingApi from "../../../api/server/modeling";
import GroupApi from "../../../api/server/group";

export default {
    name: "modelingdetail",
    watch: {
        $route: "requestData",
    },
    components: {
        GroupToModelingDialog
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async saveModeling() {
            this.data.content = JSON.stringify(this.content);
            await ModelingApi.modelingUpdate(this.data);
            this.showSuccess()
        },
        async requestData() {
            var data = await ModelingApi.modelingDetail(this.$route.params.id);
            this.content = JSON.parse(data.content); 
            this.data = data;
            this.groups = await GroupApi.list();
        },
        confirmModal(modalData) {
            this.modalData = modalData
            this.data.groupName = modalData.name
            this.data.groupId = modalData.id
            this.closeModal()
        },
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false; 
        },
        groupCheck(group, event) {
            if(!this.content.groups) this.content.groups = [];

            if(event.target.checked) {
                var index =  this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index < 0) {
                    this.content.groups.push({ "groupId": group.id })
                }
            } else {
                var index = this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index >= 0) {
                    this.content.groups.splice(index, 1);
                }
            }
        },
        isGroupChecked(item) {
            return this.content["groups"]?.findIndex(f => f["groupId"] == item.id) >= 0;
        }
    },
    notifications: {
        showSuccess: { 
            title: 'success',
            message: 'modelingUpdated',
            type: 'success'
        }
    },
    data() {
        return {
            groups: [],
            content: {},
            data: {
                name: "",
                groupName: "",
                groups: [],
                groupId: 0
            },
            isModalVisible: false
        }
    }
};
</script>